import styled from '@emotion/styled';
import theme from '../../constants/theme';

type CardProps = {
  width?: string;
  theme?: typeof theme;
};

const Card = styled.div<CardProps>`
  background-color: ${(props) => props.theme.colors.white};
  padding: 32px 24px;
  border-radius: 8px;
  box-shadow: ${(props) => props.theme.shadows.shadow1};
  border: none;
  outline: none;
  transition: all 0.1s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 90vw;
  max-width: ${(props) => (props.width ? `${props.width}` : '336px')};
  margin: auto;
`;

export default Card;
